var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomecomponent = function SvgHomecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.886.212c.36-.28.867-.28 1.228 0l9 7A1 1 0 0 1 20.5 8v11a3 3 0 0 1-3 3h-14a3 3 0 0 1-3-3V8a1 1 0 0 1 .386-.79zM8.5 12v8h4v-8z"
  })));
};
export default SvgHomecomponent;